<script>
    import { required } from "vuelidate/lib/validators";
    import Customers from '@/services/Customers';
    import Business from "@/services/Business";
    import validationMessages from '@/components/validations'
    import Multiselect from "vue-multiselect";
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";

    export default {
        components:{
            validationMessages,
            Multiselect,
            vueDropzone:vue2Dropzone
        },
        props: {
            businessMemberData: {
                type: Object,
                default: ()=>({
                    id:'',
                    first_name : '',
                    last_name : '',
                    email : '',
                    company_role : '',
                    phone : '',
                    linkedin_url : '',
                    profile_url : '',
                }),
            },
        },
        watch: {
            businessMemberData: {
                immediate: true,
                deep: true,
                handler(newVal) {
                    if (newVal) {
                        this.id = newVal.customer_id;
                        this.first_name = newVal.name;
                        this.last_name = newVal.surname;
                        this.email = newVal.email;
                        this.company_role = newVal.company_role;
                        this.phone = newVal.phone_number;
                        this.linkedin_url = newVal.linkedin_url;
                        this.profile_url = newVal.profile_url;
                        this.photoDeleted = false;
                    }
                },
            }
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                id: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                company_role: '',
                linkedin_url: '',
                profile_url: '',
                availableLabels: [],
                selectedLabels: [],
                initialLabelIds: [],

                submitted: false,
                showModal: false,
                tryingToEdit: false,
                acceptedFileTypeErrorMessage:'',
                acceptedFileTypeError:false,
                photoDeleted:false,
                dropzoneOptions_profile_url: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 5,
                    acceptedFiles: 'image/jpeg,image/png,image/gif,image/bmp,image/webp',
                    maxFiles: 1,
                },
            };
        },
        validations: {
            first_name: {
                required,
            },
            last_name: {
                required,
            },
        },
        methods: {
            selectFileHome(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_profile_url.getQueuedFiles();
                    if(files[0].accepted == false){
                      console.log('File not accepted');
                      this.acceptedFileTypeErrorMessage = 'File not accepted | Accepted formats are png, jpg, gif, bmp, webp | Max size 5MB';
                      this.acceptedFileTypeError = true;
                    }else{
                      this.acceptedFileTypeErrorMessage = '';
                      this.acceptedFileTypeError = false;
                    }
                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only select one image');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_profile_url.removeFile(value);
                        });
                    }
                    this.profile_url = queuedFiles[0];
                    // this.photoDeletedHome = false;
                }, 250);
            } ,
            deleteImage() {
                this.photoDeleted = true;
                this.profile_url = '';
            },
            async fetchBusinessLabels() {
                try {
                    const response = await Customers.getCustomersLabel({
                        is_business_label: 1,
                        active: 1,
                    });
                    this.availableLabels = response.data.data || [];
                } catch (error) {
                    this.availableLabels = [];
                }
            },
            labelBadgeStyle(label) {
                const bg = label.color || "#6c757d";
                return {
                    backgroundColor: bg,
                    color: this.labelTextColor(bg),
                };
            },
            labelTextColor(hex) {
                if (!hex) {
                    return "#fff";
                }
                const color = hex.replace("#", "");
                if (color.length !== 6) {
                    return "#fff";
                }
                const r = parseInt(color.substring(0, 2), 16);
                const g = parseInt(color.substring(2, 4), 16);
                const b = parseInt(color.substring(4, 6), 16);
                const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
                return luminance > 0.6 ? "#212529" : "#fff";
            },
            buildLabelChanges() {
                const selectedIds = this.selectedLabels.map((label) => Number(label.id));
                const initialIds = this.initialLabelIds.map((id) => Number(id));
                return {
                    label_ids: selectedIds.filter((id) => !initialIds.includes(id)),
                    remove_label_ids: initialIds.filter((id) => !selectedIds.includes(id)),
                };
            },
            syncSelectedLabelsFromMember() {
                const memberLabels = this.businessMemberData?.labels || [];
                const memberLabelIds = memberLabels.map((label) => Number(label.id));

                memberLabels.forEach((memberLabel) => {
                    const exists = this.availableLabels.some(
                        (option) => Number(option.id) === Number(memberLabel.id)
                    );
                    if (!exists) {
                        this.availableLabels.push({ ...memberLabel });
                    }
                });

                this.selectedLabels = this.availableLabels.filter((option) =>
                    memberLabelIds.includes(Number(option.id))
                );
                this.initialLabelIds = [...memberLabelIds];
            },
            async onModalShown() {
                await this.fetchBusinessLabels();
                this.syncSelectedLabelsFromMember();
            },
            async editCustomer(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                    try {
                        const { label_ids, remove_label_ids } = this.buildLabelChanges();
                        const formData = new FormData();
                        formData.append("name", this.first_name);
                        formData.append("surname", this.last_name);
                        formData.append("email", this.email);
                        formData.append("phone_number", this.phone || "");
                        formData.append("company_role", this.company_role || "");
                        formData.append("linkedin_url", this.linkedin_url || "");
                        formData.append("csrf_token", this.csrf_token);
                        formData.append("_method", "PATCH");

                        if (this.profile_url && typeof this.profile_url === "object") {
                            const file = this.profile_url.file || this.profile_url;
                            formData.append("profile_url", file);
                        } else if (this.profile_url) {
                            formData.append("profile_url", this.profile_url);
                        }

                        label_ids.forEach((labelId) => formData.append("label_ids[]", labelId));
                        remove_label_ids.forEach((labelId) => formData.append("remove_label_ids[]", labelId));

                        await Business.editBusinessMember(this.id, formData).then((response) => {
                            this.successmsg("Change successfully saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg("Failed to save changes")
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false;
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }
                }
                this.tryingToEdit = false;
            },

            refreshData() {
                this.$emit('onRefresh') //event from parent
            },

            closeModal() {
                this.showModal = false;
            },

            resetProps(){
                this.submitted = false;
                this.selectedLabels = [];
                this.initialLabelIds = [];
                this.availableLabels = [];
            }
        },

    };
</script>

<template>
    <b-modal @hidden="resetProps" @shown="onModalShown" v-model="showModal" id="business_member_edit" title="Edit Business User" title-class="font-18" centered>
        <form @submit.prevent="editCustomer">

            <b-form-group label="First Name" label-for="formrow-first_name-input" class="mb-3">
                <b-form-input
                        v-model.trim="first_name"
                        type="text"
                        id="first_name"
                        aria-describedby="first_name-feedback"
                        :class="{
                      'is-invalid': submitted && $v.first_name.$error,
                    }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'First Name'" :validationName="$v.first_name"></validationMessages>
            </b-form-group>
            <b-form-group label="Surname" label-for="formrow-last_name-input" class="mb-3">
                <b-form-input
                        v-model.trim="last_name"
                        type="text"
                        id="last_name"
                        aria-describedby="last_name-feedback"
                        :class="{
                      'is-invalid': submitted && $v.last_name.$error,
                    }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'Last Name'" :validationName="$v.last_name"></validationMessages>
            </b-form-group>
            <b-form-group label="Email" label-for="formrow-email-input" class="mb-3">
                <b-form-input
                        v-model.trim="email"
                        type="text"
                        id="email"
                        aria-describedby="email-feedback"

                >
                </b-form-input>
            </b-form-group>
            <b-form-group label="Phone" label-for="formrow-phone-input" class="mb-3">
                <b-form-input
                        v-model.trim="phone"
                        type="text"
                        id="email"
                        aria-describedby="phone-feedback"
                >
                </b-form-input>
            </b-form-group>
            <b-form-group label="Company Role" label-for="formrow-company_role-input" class="mb-3">
                <b-form-input
                        v-model.trim="company_role"
                        type="text"
                        id="email"
                        aria-describedby="company_role-feedback"
                >
                </b-form-input>
            </b-form-group>
            <b-form-group label="Linked In URL" label-for="formrow-linkedin_url-input" class="mb-3">
                <b-form-input
                        v-model.trim="linkedin_url"
                        type="text"
                        id="email"
                        aria-describedby="linkedin_url-feedback"

                >
                </b-form-input>
            </b-form-group>
            <b-form-group label="Labels" label-for="business-member-labels" class="mb-3">
                <multiselect
                    id="business-member-labels"
                    class="label-multiselect"
                    v-model="selectedLabels"
                    :options="availableLabels"
                    :multiple="true"
                    :close-on-select="false"
                    label="name"
                    track-by="id"
                    placeholder="Select labels"
                >
                    <template slot="option" slot-scope="{ option }">
                        <span
                            class="label-option-swatch me-2"
                            :style="{ backgroundColor: option.color || '#6c757d' }"
                        />
                        <span>{{ option.name }}</span>
                    </template>
                    <template slot="tag" slot-scope="{ option, remove }">
                        <span class="multiselect__tag label-multiselect-tag" :style="labelBadgeStyle(option)">
                            {{ option.name }}
                            <i class="multiselect__tag-icon" @click="remove(option)" aria-hidden="true"></i>
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group label="Profile Image" label-for="formrow-profile_url-input" class="mb-3">
                <template v-if="!photoDeleted && profile_url">
                    <b-form-group label-for="image" class="mb-3 text-center image-area">
                       <img :src="profile_url ? `${profile_url}?ts=${Date.now()}` : require('@/assets/images/image_not_found.png')" alt="" width="50" class="img-thumbnail" >

                    </b-form-group>
                    <div class="text-center mt-3">
                        <a class="btn text-danger"  title="Delete Image" @click="deleteImage">
                            <i class="uil uil-trash-alt font-size-18"></i>
                        </a>
                    </div>
                </template>
                <template v-else>
                    <vue-dropzone
                            id="dropzone_profile_url"
                            ref="myVueDropzone_profile_url"
                            :use-custom-slot="true"
                            :options="dropzoneOptions_profile_url"
                            @vdropzone-files-added="selectFileHome"
                            no-progress-bar
                    >
                        <div class="dropzone-custom-content">
                            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                            <h4>Drop file here or click to upload.</h4>
                        </div>
                    </vue-dropzone>
                </template>
              <p v-if="acceptedFileTypeError" class="text-danger">{{acceptedFileTypeErrorMessage}}</p>
            </b-form-group>



            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="editCustomer" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Change</b-button>
        </template>
    </b-modal>
</template>

<style scoped>
.label-option-swatch {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    vertical-align: middle;
}

</style>